import { render, staticRenderFns } from "./schedulebooking.vue?vue&type=template&id=2deb1bfb&"
import script from "./schedulebooking.vue?vue&type=script&lang=js&"
export * from "./schedulebooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports